/*
 * @Descripttion:
 * @Author:
 * @Date: 2020-07-09 09:23:46
 * @LastEditors: zuishuanicx 1342142818@qq.com
 * @FilePath: \dzCloud\src\projects\tiktok\store.js
 */

import { ajax, publicURL } from './../../plugins/axios.js';

const state = {
    activeIndex: '0',
    number: '1',
    menus: [
        {
            name: '货源推荐',
            path: '/source',
            subMens: [],
            activeIndex: '-1',
            isOpen: false,
            isToLink: false,
        },
        {
            name: '商品铺货',
            path: '/',
            subMens: [
                {
                    name: '开始铺货',
                    path: '/',
                    icon: '',
                },
                {
                    name: '铺货记录',
                    path: '/',
                    icon: '',
                },
            ],
            activeIndex: '0',
            isOpen: false,
            isToLink: false,
        },
        {
            name: '商品管理',
            path: '/commodityMGT',
            subMens: [],
            activeIndex: '1',
            isOpen: false,
            isToLink: false,
        },
        {
            name: '批量修改',
            path: '/batchModify',
            subMens: [],
            activeIndex: '2',
            isOpen: false,
            isToLink: false,
        },
        {
            name: '订单打印',
            path: 'https://fuwu.jinritemai.com/authorize?service_id=285',
            activeIndex: '3',
            subMens: [],
            isOpen: false,
            isToLink: true,
        },
        {
            name: '短信营销',
            path: 'https://dycrm.dazeyun.com/',
            activeIndex: '4',
            subMens: [],
            isOpen: true,
            isToLink: true,
        },
        {
            name: '使用教程',
            path: 'http://newhelp.fjdaze.com/help_yshzs/list-96.html',
            activeIndex: '5',
            subMens: [],
            isOpen: true,
            isToLink: true,
        },
        {
            name: '批量采购',
            path: 'http://pddcopy.fjdaze.com/pages/pddcopy/#/plcg1688',
            activeIndex: '6',
            subMens: [],
            isOpen: true,
            isToLink: true,
        },
        // { name: "绑定店铺", path: "/binding", subMens: [] }
    ],
    userInfo: {}, //当前信息
    categoryData: [],
    // 文字
    textMessage: '',
    // index页面文字是否展示
    isTextMessage: false,
    // 商品铺货页面
    indexOptions: [],
    userConfig: {},
    recordId: '',
    classQuality: [],
    qualityReport: [],
    shopList: [], //店铺
};

const mutations = {
    setActiveIndex(state, data) {
        if (data == '') {
            data = '0';
        }
        state.activeIndex = data;
    },
    setMessage(state, data) {
        state.textMessage = data;
    },
    setIsTextMessage(state, data) {
        state.isTextMessage = data;
    },
    recordIdFun(state, data) {
        state.recordId = data;
    },
    classQualityFun(state, data) {
        state.classQuality = data;
    },
    qualityReportFun(state, data) {
        state.qualityReport = data;
    },
    userInfoRun(state, data) {
        state.userInfo = data;
    },
    /* categoryRun(state, data) {
    state.categoryData = data;
  }, */
    getShopRun(state, data) {
        state.shopList = data;
    },
};

const getters = {};

const actions = {
    setUserInfoRunAsync({ commit }) {
        return new Promise((resolve, reject) => {
            if (Object.keys(state.userInfo).length) {
                resolve(state.userInfo);
            } else {
                ajax.get('/api/tiktok/User/Get')
                    .then((res) => {
                        if (res.code == 200) {
                            localStorage.setItem('userInfo', JSON.stringify(res.result));
                            commit('userInfoRun', res.result);
                            resolve(res.result);
                        }
                    })
                    .catch(reject);
            }
        });
    },
    // 获取类目
    // eslint-disable-next-line no-unused-vars
    getGetShopLeafCategory({ commit }, { isSync }) {
        return new Promise((resolve, reject) => {
            ajax.post('/cloud/setting/api/tiktok/Category/GetShopLeafCategory', { isSync: isSync })
                .then((res) => {
                    if (res.code === 200) {
                        resolve(res.result);
                    }
                })
                .catch(reject);
        });
    },
    getShopInfosByMemberId({ commit }) {
        return new Promise((resolve, reject) => {
            ajax.post(publicURL + '/multiShopManager/getShopInfosByMemberId')
                .then((res) => {
                    if (res.code == 200) {
                        commit('getShopRun', res.data);
                        resolve();
                    }
                })
                .catch(reject);
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
